"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlsGeneralFilterControl = void 0;
const DOM_1 = require("../../../../public/js/utils/DOM");
const Form_1 = require("../../Form/Form");
const TableControl_1 = require("../TableControl/TableControl");
var ControlsGeneralFilterControl;
(function (ControlsGeneralFilterControl) {
    class Config {
        static activeClassName = "open";
        static dropDownClassName = "FilterControl-content-inside";
        static submitClass = "filterControlSave";
        static clearClass = "filterControlClear";
        static buttonClassName = "FilterControl-content-button";
        static filterCloseElementClass = "filterClose";
    }
    class Utils {
        static getFilterDataByFilterId(filterId) {
            return Form_1.ControlsForm.Controller.getFormData(DOM_1.DOM.Parser.getElementByTag('form', DOM_1.DOM.Parser.getHtmlElement(filterId)));
        }
        static getFilterActiveByFilterId(filterId) {
            return DOM_1.DOM.Parser.getHtmlElement(filterId).classList.contains(Config.activeClassName);
        }
        static disableEnableActionsInFilter(filterId, disabled) {
            const buttons = DOM_1.DOM.Parser.getHtmlElementsByQuery('button', DOM_1.DOM.Parser.getHtmlElement(filterId));
            for (let i = 0; i < buttons.length; i++) {
                buttons[i].disabled = disabled;
            }
        }
    }
    ControlsGeneralFilterControl.Utils = Utils;
    class Control {
        filterElement;
        filterId;
        sendFilterActionCallback;
        clearSuccessCallback;
        componentNameIncluded;
        constructor(filterId, componentNameIncluded, sendFilterActionCallback, clearSuccessCallback) {
            this.componentNameIncluded = componentNameIncluded;
            this.sendFilterActionCallback = sendFilterActionCallback;
            this.clearSuccessCallback = clearSuccessCallback;
            this.filterElement = DOM_1.DOM.Parser.getHtmlElement(filterId);
            this.filterId = filterId;
            this.triggerHideOnOutsideClick();
            this.triggerDropDown();
            this.triggerSend();
            this.triggerClear();
            this.triggerClose();
        }
        triggerClose() {
            DOM_1.DOM.Parser.getHtmlElementByClass(Config.filterCloseElementClass, this.filterElement).addEventListener('click', () => {
                this.filterElement.classList.remove(Config.activeClassName);
            });
        }
        triggerClear() {
            TableControl_1.ControlsGeneralTableControl.Filter.triggerClearFilter(DOM_1.DOM.Parser.getHtmlElementByClass(Config.clearClass, this.filterElement), this.componentNameIncluded, () => { this.clearSuccessCallback(); });
        }
        triggerSend() {
            TableControl_1.ControlsGeneralTableControl.Filter.triggerSendFilter(DOM_1.DOM.Parser.getElementByTag('form', this.filterElement), DOM_1.DOM.Parser.getHtmlElementByClass(Config.submitClass, this.filterElement), (event) => { this.sendFilterActionCallback(event); });
        }
        triggerHideOnOutsideClick() {
            window.addEventListener('click', (evt) => {
                const filterElement = document.getElementById(this.filterId);
                if (filterElement === null || !filterElement.classList.contains(Config.activeClassName)) {
                    return;
                }
                const clickedInside = DOM_1.DOM.Parser.parentContainsTheClass(Config.dropDownClassName, evt.target)
                    || DOM_1.DOM.Parser.parentContainsTheClass('flatpickr-calendar', evt.target);
                if (clickedInside) {
                    return;
                }
                filterElement.classList.remove(Config.activeClassName);
            });
        }
        triggerDropDown() {
            const button = DOM_1.DOM.Parser.getHtmlElementByClass(Config.buttonClassName, this.filterElement);
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.filterElement.classList.toggle(Config.activeClassName);
            });
        }
    }
    ControlsGeneralFilterControl.Control = Control;
})(ControlsGeneralFilterControl || (exports.ControlsGeneralFilterControl = ControlsGeneralFilterControl = {}));
